module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf1-3.8fb9abd3.png";